import { useState } from "react";

const ZoneTracker = ({ status }) => {
  const [fortOnly, setFortsOnly] = useState(false);
  const ELF = [
    "Shining Way",
    "Eataine",
    "Dragonwake",
    "Caledor",
    "Fell Landing",
  ];

  const DAWI = [
    "Stonewatch",
    "Kadrin Valley",
    "Thunder Mountain",
    "Black Crag",
    "Butcher's Pass",
  ];

  const FORTS = [
    "Stonewatch",
    "Butcher's Pass",
    "Shining Way",
    "Fell Landing",
    "Reikwald",
    "The Maw",
  ];

  const EMP = ["Reikwald", "Reikland", "Praag", "Chaos Wastes", "The Maw"];
  const zoneClass = " h-4 border border-gray-800";

  const Zone = ({ name, kills }) => {
    const oKills = kills.order_kills;
    const dKills = kills.destro_kills;
    const oPer = oKills / (oKills + dKills);
    const orderWidth = `${oPer * 100}%`;

    let opacity = kills.total_kills / 400;

    if (fortOnly && !FORTS.includes(name)) {
      return <EmptyZone></EmptyZone>;
    }

    if (dKills + oKills > 0) {
      return (
        <div className={zoneClass}>
          <div className={`bg-red-500 h-4`} style={{ opacity: opacity }}>
            <div className="bg-sky-500 h-full" style={{ width: orderWidth }}>
              &nbsp;
            </div>
          </div>
        </div>
      );
    }

    return <EmptyZone />;
  };

  const EmptyZone = () => {
    return <div className={zoneClass}></div>;
  };

  const getTime = (datetime) => {
    const time = datetime.split("T")[1];
    return time.substring(0, 5);
  };
  const getDate = (datetime) => {
    const date = datetime.split("T")[0];
    return date;
  };

  let width = window.innerWidth;
  const strLength = width < 450 ? 3 : 6;

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-12">
        <div></div>
        <div className="hidden md:block"></div>
        <div className="hidden md:block"></div>
        <div></div>
        <div className="my-5 space-x-2 col-span-5">
          <input
            type="checkbox"
            value={fortOnly}
            checked={fortOnly}
            onClick={() => setFortsOnly(!fortOnly)}
          />
          <label>Forts Only</label>
        </div>
      </div>

      <div className="grid grid-cols-12 text-xxs text-gray-400 text-center">
        <div></div>
        <div className="hidden md:block"></div>
        <div className="hidden md:block">Pop.</div>
        <div className="text-left"></div>
        <div className="col-span-10 md:col-span-8 grid grid-cols-3 gap-2 md:gap-5">
          <div className="grid grid-cols-5">
            {ELF.map((z) => {
              return <div>{z.substring(0, strLength)}</div>;
            })}
          </div>
          <div className="grid grid-cols-5">
            {EMP.map((z) => {
              return <div>{z.substring(0, strLength)}</div>;
            })}
          </div>
          <div className="grid grid-cols-5">
            {DAWI.map((z) => {
              return <div>{z.substring(0, strLength)}</div>;
            })}
          </div>
        </div>
      </div>
      {status.map((st) => {
        if (!st.kills) {
          return null;
        }
        if (fortOnly) {
          const zones = Object.keys(st.kills);
          const found = zones.some((r) => FORTS.indexOf(r) >= 0);
          if (!found) {
            return null;
          }
        }
        return (
          <div className="grid grid-cols-12  text-xxs text-center">
            <div>{getTime(st.created_at)}</div>
            <div className="hidden md:block">{getDate(st.created_at)}</div>
            <div className="hidden md:block">{st.population["population"]}</div>
            <div>
              <div
                className=" h-2"
                style={{
                  width: st.population["population"] / 20 + "%",
                  backgroundColor: "#f90",
                }}
              ></div>
            </div>
            <div className="col-span-10 md:col-span-8 grid grid-cols-3 gap-2 md:gap-5">
              <div className="grid grid-cols-5">
                {ELF.map((z) => {
                  if (st.kills[z]) {
                    return <Zone name={z} kills={st.kills[z]}></Zone>;
                  } else {
                    return <EmptyZone />;
                  }
                })}
              </div>

              <div className="grid grid-cols-5">
                {EMP.map((z) => {
                  if (st.kills[z]) {
                    return <Zone name={z} kills={st.kills[z]}></Zone>;
                  } else {
                    return <EmptyZone />;
                  }
                })}
              </div>
              <div className="grid grid-cols-5">
                {DAWI.map((z) => {
                  if (st.kills[z]) {
                    return <Zone name={z} kills={st.kills[z]}></Zone>;
                  } else {
                    return <EmptyZone />;
                  }
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ZoneTracker;
